// extracted by mini-css-extract-plugin
export default {"wrapper":"dt-z","response":"et-z","error":"ft-z","disabled":"gt-z","buttons":"ht-z","feedbackQuestionSection":"it-z","yesNoWrapper":"jt-z"};